import React from 'react';
import { ActivityIndicator, StyleSheet, Text, TouchableOpacity, ViewStyle } from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import { Platform } from 'react-native';

export interface TravelExportPdfButtonProps {
  onPress: () => void;
  loading?: boolean;
  disabled?: boolean;
  t?: (key: string) => string;
  style?: ViewStyle;
  labelOverride?: string;
}

const defaultStrings: Record<string, string> = {
  exportLabel: '导出 PDF',
  exporting: '导出中...',
};

const resolveLabel = (t: ((key: string) => string) | undefined, key: keyof typeof defaultStrings) => {
  if (!t) return defaultStrings[key];
  try {
    const value = t(`travelDetail.actions.${key}`);
    if (value && value !== `travelDetail.actions.${key}`) {
      return value;
    }
  } catch (error) {
    // ignore
  }
  try {
    const value = t(`expenseManagement.${key}`);
    if (value && value !== `expenseManagement.${key}`) {
      return value;
    }
  } catch (error) {
    // ignore
  }
  return defaultStrings[key];
};

const TravelExportPdfButton: React.FC<TravelExportPdfButtonProps> = ({
  onPress,
  loading = false,
  disabled = false,
  t,
  style,
  labelOverride,
}) => {
  const label = labelOverride ? labelOverride : resolveLabel(t, loading ? 'exporting' : 'exportLabel');

  const RenderIcon: React.FC<{ name: string; size?: number; color?: string }> = ({ name, size = 18, color = '#4B5563' }) => {
    const resolvedName = name ? name.replace(/-/g, '_') : name;
    return <Icon name={resolvedName} size={size} color={color} />;
  };

  return (
    <TouchableOpacity
      style={[styles.button, (disabled || loading) && styles.disabledButton, style]}
      onPress={onPress}
      activeOpacity={0.8}
      disabled={disabled || loading}
    >
      {loading ? (
        <ActivityIndicator size="small" color="#4B5563" />
      ) : (
        <RenderIcon name="file-download" />
      )}
      <Text style={styles.label}>{label}</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 24,
    backgroundColor: '#F8FAFC',
    borderWidth: 1,
    borderColor: '#E2E8F0',
    gap: 8,
  },
  disabledButton: {
    opacity: 0.6,
  },
  label: {
    fontSize: 14,
    fontWeight: '600',
    color: '#4B5563',
  },
});

export default TravelExportPdfButton;
